// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oj-5";
export var filledCircle = "_oj-4";
export var historyEntry = "_oj-3";
export var messageSideLeft = "_oj-1";
export var messageSideRight = "_oj-2";
export var orderTrackingCarouselWrapper = "_oj-6";
export var orderTrackingInfoContainer = "_oj-0";